import { render, staticRenderFns } from "./HacksTable.vue?vue&type=template&id=6f0c75e3&lang=pug"
import script from "./HacksTable.vue?vue&type=script&lang=ts"
export * from "./HacksTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports